/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/
export var conf = {
    comments: {
        blockComment: ["`", "`"]
    },
    brackets: [
        ['{', '}'],
        ['[', ']'],
        ['(', ')']
    ],
    autoClosingPairs: [
        { open: '{', close: '}' },
        { open: '[', close: ']' },
        { open: '(', close: ')' },
        { open: '"', close: '"', notIn: ['string'] },
        { open: "'", close: "'", notIn: ['string', 'comment'] }
    ],
    surroundingPairs: [
        { open: '{', close: '}' },
        { open: '[', close: ']' },
        { open: '(', close: ')' },
        { open: '"', close: '"' },
        { open: "'", close: "'" }
    ],
    folding: {
        offSide: true,
        markers: {
            start: new RegExp('^\\s*#region\\b'),
            end: new RegExp('^\\s*#endregion\\b')
        }
    }
};
export var language = {
    defaultToken: 'invalid',
    tokenPostfix: '.ink',
    keywords: [
        'true',
        'false'
    ],
    builtins: [
        'load',
        'args',
        'in',
        'out',
        'dir',
        'make',
        'stat',
        'read',
        'write',
        'delete',
        'listen',
        'req',
        'rand',
        'urand',
        'time',
        'wait',
        'exec',
        'env',
        'exit',
        'sin',
        'cos',
        'asin',
        'acos',
        'pow',
        'ln',
        'floor',
        'string',
        'number',
        'point',
        'char',
        'type',
        'len',
        'keys',
    ],
    typeKeywords: [
        'std',
        'str',
        'log',
        'scan',
        'hToN',
        'nToH',
        'hex',
        'xeh',
        'min',
        'max',
        'range',
        'clamp',
        'slice',
        'append',
        'join',
        'clone',
        'stringList',
        'reverse',
        'map',
        'filter',
        'reduce',
        'reduceBack',
        'flatten',
        'some',
        'every',
        'cat',
        'each',
        'encode',
        'decode',
        'readFile',
        'writeFile',
        'format',
        'lower',
        'upper',
        'title',
        'replaceNonEmpty',
        'replace',
        'splitNonEmpty',
        'split',
        'trimPrefixNonEmpty',
        'trimPrefix',
        'trimSuffixNonEmpty',
        'trimSuffix',
        'trim',
    ],
    brackets: [
        { open: '{', close: '}', token: 'delimiter.curly' },
        { open: '[', close: ']', token: 'delimiter.bracket' },
        { open: '(', close: ')', token: 'delimiter.parenthesis' }
    ],
    tokenizer: {
        root: [
            { include: '@whitespace' },
            { include: '@numbers' },
            { include: '@strings' },
            [/[,:;]/, 'delimiter'],
            [/[{}\[\]()]/, '@brackets'],
            [/@[a-zA-Z_]\w*/, 'tag'],
            [
                /[a-zA-Z_]\w*/,
                {
                    cases: {
                        '@keywords': 'keyword',
                        '@builtins': 'type.identifier',
                        '@typeKeywords': 'keyword.flow',
                        '@default': 'identifier'
                    }
                }
            ]
        ],
        // Deal with white space, including single and multi-line comments
        whitespace: [
            [/\s+/, 'white'],
            [/`/, 'comment', '@comment'],
        ],
        comment: [
            [/[^`]+/, 'comment'],
            [/`/, 'comment', '@pop'],
            [/[`]/, 'comment']
        ],
        // Recognize hex, negatives, decimals, imaginaries, longs, and scientific notation
        numbers: [
            [/-?0x([abcdef]|[ABCDEF]|\d)+[lL]?/, 'number.hex'],
            [/-?(\d*\.)?\d+([eE][+\-]?\d+)?[jJ]?[lL]?/, 'number']
        ],
        // Recognize strings, including those broken across lines with \ (but not without)
        strings: [
            [/'/, 'string.escape', '@stringBody'],
        ],
        stringBody: [
            [/[^\\']+/, 'string'],
            [/\\./, 'string'],
            [/'/, 'string.escape', '@popall'],
            [/\\$/, 'string']
        ],
    }
};
